import { Modal } from '@Core/Components/Modal/Modal'
import { Grid } from '@material-ui/core'
import { Button, ButtonVariant } from '@Core/Components'
import { PipedriveProductSearch } from './PipedriveProductSearch'

export const PipedriveProduct = ({
    isOpen,
    onClose,
    control,
    setValue,
    state,
    prefixName,
    disabled = false,
}: {
    isOpen: boolean
    onClose: () => void
    control: any
    setValue: any
    state: any
    prefixName: string
    disabled?: boolean
}) => {
    const handleConfirm = () => {
        onClose()
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="grid grid-cols-1 gap-4">
                <h2 className="text-lg font-semibold">
                    Vincular Produto (Pipedrive)
                </h2>
                <Grid container spacing={2}>
                    <Grid item xs={12} lg={12}>
                        <PipedriveProductSearch
                            control={control}
                            setValue={setValue}
                            state={state}
                            prefixName={prefixName}
                            disabled={disabled}
                        />
                    </Grid>
                </Grid>
                <div className="flex justify-end gap-2 mt-4">
                    <Button
                        type="button"
                        variant={ButtonVariant.secondary}
                        onClick={onClose}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="button"
                        disabled={disabled}
                        onClick={handleConfirm}
                        variant={ButtonVariant.primary}
                    >
                        Adicionar
                    </Button>
                </div>
            </div>
        </Modal>
    )
}
